import { render, staticRenderFns } from "./page-jobs-by-sectors.vue?vue&type=template&id=c1e62552"
import script from "./page-jobs-by-sectors.vue?vue&type=script&lang=js"
export * from "./page-jobs-by-sectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports